import React from 'react';

import Cabecalho from 'Component/Cabecalho';
import LayoutDefault from 'Component/Layout';
import { useAppSelector } from 'Store';

import Aniversarios from './Aniversarios';
import Comunicados from './Comunicados';
import EmprestimosEpi from './EmprestimosEpi';
import EmprestimosUniforme from './EmprestimosUniforme';
import Folgas from './Folgas';
import Folhas from './Folhas';
import Holerites from './Holerites';
import MeuAniversario from './MeuAniversario';
import Pontos from './Pontos';
import Sistemas from './Sistemas';

const Default = (): React.ReactElement => {
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  return (
    <LayoutDefault>
      <Cabecalho
        titulo={`Bem-vindo novamente, ${usuario?.nome}!`}
        descricao="Sua tela inicial com tudo de importante em um lugar só!"
      />
      <div className="row">
        <div className="col-md-12">
          <Folgas />
          <Pontos />
          <Folhas />
          <Holerites />
          <EmprestimosEpi />
          <EmprestimosUniforme />
        </div>
        <div className="col-md-12 mb-3">
          <Sistemas />
        </div>
        <div className="col-md-6 mb-3">
          <Comunicados />
        </div>
        <div className="col-md-6 mb-3">
          <Aniversarios />
        </div>
      </div>
      <MeuAniversario />
    </LayoutDefault>
  );
};

export default Default;
